/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const FilterHideCircleSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12 22a9.955 9.955 0 0 0 5.827-1.872L13.5 15.801v.028a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.528l-1.5-1.5H8.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.028l-1.5-1.5H6.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h.028L3.872 6.173A9.955 9.955 0 0 0 2 12c0 5.523 4.477 10 10 10Zm6.98-2.84A9.97 9.97 0 0 0 22 12c0-5.523-4.477-10-10-10-2.304 0-4.427.78-6.118 2.09-.391.302-.76.634-1.102.991L18.919 19.22l.061-.06Zm-3.857-5.83h.377a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-1.877l1.5 1.5Zm-3-3H17.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-6.877l1.5 1.5Z" /></svg>);
const FilterHideCircleSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={FilterHideCircleSolidBase} {...rest} ref={ref} />);
export default FilterHideCircleSolid;